import React from 'react';
import { FaCloudUploadAlt, FaCrop, FaFileExport } from 'react-icons/fa';
import Typewriter from 'typewriter-effect';
import InfoCards from './InfoCards';

function Instrucciones() {
  return (
    <>
      <section className="text-center mb-4 col-lg-10" >
        <h1 className="display-2 fw-bold">
          Protege tu DNI 
          <span style={{ color: '#FF9800' }}>
            <Typewriter
              options={{
                strings: ['100% seguro', 'fácil', 'rápido'],
                autoStart: true,
                loop: true,
                speed: 20,
                deleteSpeed: 100,
                delay: 100,
                pauseFor: 500,
              }}
            />
          </span>
        </h1>
        <h2 className="lead my-2 mx-4 display-6" style={{ color: '#222831' }}>Edita, guarda y comparte tu documento de identidad nacional de manera segura</h2>
      </section>

      <section className='row justify-content-center'>
        <div className='col-md-6 col-10'>
          <InfoCards />
        </div>
      </section>
    </>
  );
}

export default Instrucciones;